module.exports = __webpack_public_path__ + "assets/img/quick-active.6542cb71.png";